import Button from "../../../custom/button/button";
import { ReactComponent as Edit } from "../../../assets/Edit.svg";
import { ReactComponent as Document } from "../../../assets/Group (5).svg";
import { ReactComponent as DownloadPdf } from "../../../assets/Export Pdf.svg";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import styles from "../dashboardPage.module.scss";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App, Modal, Spin } from "antd";
import {
  createUpdateWorkHistory,
  getWorkHistoryById,
} from "../../../utils/request";
import { formatDate } from "../../../utils/formatDate";
import WorkHistoryForm from "../../../components/onboardingSteps/workHistory/form";

const WorkHistoryView = () => {
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const user = useAtomValue(userAtom);

  const queryClient = useQueryClient();
  const { notification } = App.useApp();

  const { data, isLoading } = useQuery({
    queryKey: ["get-work-history-id"],
    queryFn: () => getWorkHistoryById(Number(id)),
    enabled: !!Number(id)
  });

  const workHistoryData = data?.data ?? ({} as WorkHistoryData);

  const workHistory = [
    {
      company: workHistoryData?.companyName,
      position: workHistoryData?.position,
      currentJob: workHistoryData?.isCurrentJob,
      startDate: formatDate(workHistoryData?.startDate),
      endDate: formatDate(workHistoryData?.endDate),
      upload: null,
    },
  ];

  const createUpdateWorkHistoryMutation = useMutation({
    mutationFn: createUpdateWorkHistory,
  });

  const handleCreateUpdateWorkHistory = async (values: WorkHistory) => {
    const formData = new FormData();

    formData.append("Id", id ?? "");
    formData.append("ApplicantId", user?.applicantId ?? '');
    formData.append("CompanyName", values.company);
    formData.append("Position", values.position);
    formData.append("IsCurrentJob", String(values.currentJob));
    formData.append("StartDate", values.startDate);
    formData.append("EndDate", values.endDate);
    if (values.upload) {
      formData.append("Emplyment", values.upload);
    }

    try {
      await createUpdateWorkHistoryMutation.mutateAsync(formData, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          queryClient.refetchQueries({ queryKey: ["get-work-history-id"] });
          setOpenModal(false);
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const handleModal = () => {
    setOpenModal((prevState) => !prevState);
  };

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <PageLayout
      heading="Work History"
      headerActions={
        <>
          <Button iconBefore={<Edit />} text="Edit" onClick={handleModal} />
          <Button
            iconBefore={<DownloadPdf />}
            text="Download"
            bgColor="#CE9938"
          />
        </>
      }
    >
      <section className={styles?.section}>
        <p>Company: {workHistoryData?.companyName}</p>
        <p>Position: {workHistoryData?.position}</p>
        <p>Start Date: {formatDate(workHistoryData?.startDate)} </p>
        <p>End date: {formatDate(workHistoryData?.endDate)} </p>
      </section>

      <section className={styles.textTable}>
        <div className={styles.textRow}>
          <div className={styles.textCell}>
            <p className={styles.title}>Evidence of employment </p>
            <Document className={styles.doc} />
            <p className={styles.doc}>{workHistoryData?.employmentUrl}</p>
            {/* <p className={styles.size}>911kb</p> */}
          </div>
          {/* <div className={styles.textCell}>
            <p className={styles.title}>NYSC </p>
            <Document className={styles.doc} />
            <p className={styles.doc}>Doc.pdf</p>
            <p className={styles.size}>911kb</p>
          </div> */}
        </div>
      </section>

      <Modal
        open={openModal}
        onCancel={handleModal}
        footer={null}
        width="720px"
      >
        <div className={styles.modalContent}>
          <div>
            <p>Work History</p>
            <p>All fields marked with a (*) are required.</p>
          </div>

          <hr />

          <br />

          <WorkHistoryForm
            editIndex={0}
            workHistory={workHistory}
            certificateUrl={workHistoryData?.employmentUrl}
            buttonText="Edit"
            onSubmit={handleCreateUpdateWorkHistory}
            isLoading={createUpdateWorkHistoryMutation?.isPending}
          />
        </div>
      </Modal>
    </PageLayout>
  );
};

export default WorkHistoryView;
